var React = require('react');
var UtilGuid = require('../../common/utilGuid.js');

require('./DialogButton.scss');

class DialogButton extends React.Component {
    constructor(props) {

        super(props);

    }

    handleDialogOpen() {

        const target = document.querySelector('[data-dialog="' + this.props.name + '"]');
        if (target) target.showModal();
    
    }

    render() {
        return (
            <button type="button" className={`c-dialog-button${this.props.additionalClass ? ` ${this.props.additionalClass}` : ""}`} data-dialog-open={this.props.name} onClick={this.handleDialogOpen.bind(this)}>
                {this.props.children}
            </button>
        );
    }
};

module.exports = DialogButton;


// WEBPACK FOOTER //
// ./src/components/Dialog/DialogButton.js